import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface MenuProps {
  onItemClick?: () => void;
  variant?: "transparent" | "white";
}

const Menu: React.FC<MenuProps> = ({ onItemClick, variant = "white" }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const menuItems = [
    {
      label: t("nav.about"),
      path: "/#about",
      isExternal: true,
    },
    {
      label: t("nav.programs"),
      path: "/programs",
      isExternal: false,
    },
    {
      label: t("nav.contact"),
      path: "/contact",
      isExternal: false,
    },
  ];

  return (
    <nav className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-8 py-3 md:py-0 w-full md:w-auto">
      {menuItems.map((item) => {
        const isActive =
          !item.isExternal &&
          (location.pathname === item.path ||
            (item.path.includes("/programs") && location.pathname.includes("/programs")));

        const desktopInactiveColor =
          variant === "transparent"
            ? "md:text-white md:hover:text-[#037897]"
            : "md:text-[#020220] md:hover:text-[#037897]";

        const desktopActiveColor =
          variant === "transparent"
            ? "md:text-white md:font-bold md:underline md:decoration-[#037897] md:underline-offset-8"
            : "md:text-[#037897] md:font-bold";

        const linkClassName = `w-full md:w-auto block py-2.5 px-4 md:px-0 text-xl md:text-lg font-semibold md:leading-10 transition-colors whitespace-nowrap rounded-lg md:rounded-none text-center ${
          isActive
            ? `text-[#037897] font-bold bg-[#037897]/10 md:bg-transparent ${desktopActiveColor}`
            : `text-[#020220] hover:text-[#037897] hover:bg-gray-50 md:hover:bg-transparent ${desktopInactiveColor}`
        }`;

        return item.isExternal ? (
          <a
            key={item.label}
            href={item.path}
            onClick={onItemClick}
            className={linkClassName}
          >
            {item.label}
          </a>
        ) : (
          <Link
            key={item.label}
            to={item.path}
            onClick={onItemClick}
            className={linkClassName}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
};

export default Menu;